import { AxiosResponse } from "axios"
import { InsuranceParamsDto, Offer, OfferAddon } from "BrokerTsLib/src/dtos"
import { Risk, RiskVariant } from "BrokerTsLib/src/enums"
import { createContext, useEffect, useState } from "react"
import { RefetchOptions, RefetchQueryFilters, QueryObserverResult } from "react-query"
import { useGetAddonOffers } from "../hooks/useOfferAddon"

type AddonOffersCtxProps = {
    addonOffers: OfferAddon[]
    refetch: <TPageData>(options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined) => Promise<QueryObserverResult<AxiosResponse<OfferAddon[], any>, any>>
    isLoadingData: boolean
}

export const addonOffersContext = createContext<AddonOffersCtxProps>({} as AddonOffersCtxProps)

export const AddonOffersProvider = ({ insuranceParams, offer, children }: { insuranceParams: InsuranceParamsDto, offer?: Offer, children: React.ReactNode }) => {
    const [addonOffers, setAddonOffers] = useState<OfferAddon[]>([])
    const { refetch: refetchAddonOffers, data: dataAddonOffers, isLoading, isFetching } = useGetAddonOffers(insuranceParams.generalParams.paramsId!.toString(), { enabled: false })
    const allAddonOffers = dataAddonOffers?.data ?? []

    useEffect(() => {
        refetchAddonOffers()
    }, []);

    useEffect(() => {
        if (allAddonOffers.length > 0) {

            let selectedAddonOffers: OfferAddon[] = []
            insuranceParams.baseParams.addonVariants
                ?.filter(x => x.selected)
                .forEach(av => {
                    // v pripade varianty allrisk + gap se hleda linkovana offera

                    if (offer && av.riskVariantId == RiskVariant.AddonGAP &&
                        insuranceParams.baseParams.variants?.
                            find(x => x.id == offer?.insuranceVariantId)?.variantParts?.
                            find(x => x.risk == Risk.HAV)?.riskVariant == RiskVariant.AllriskPlusGAP) {
                        const gapOffer = allAddonOffers.find(x => x.riskVariantId == RiskVariant.AddonGAP && (x.linkedOfferId?.includes(offer.offerId) ?? false))
                        if (gapOffer)
                            selectedAddonOffers.push(gapOffer)
                    } else {
                        selectedAddonOffers = [
                            ...selectedAddonOffers,
                            ...allAddonOffers.filter(x => x.riskVariantId == av.riskVariantId && x.isActive)
                        ]
                    }
                })

            setAddonOffers(selectedAddonOffers)
        }
    }, [offer?.offerId, allAddonOffers]);

    return (
        <addonOffersContext.Provider
            value={{
                addonOffers: addonOffers,
                refetch: refetchAddonOffers,
                isLoadingData: isLoading || isFetching
            }}>
            {children}
        </addonOffersContext.Provider>
    )
}